<div *ngIf="!environment.production" class="environment-warning">
  Warning: {{environment.title}} environment. Any changes will be lost and not saved in production!
</div>
<router-outlet></router-outlet>
